import * as React from 'react';

import { cn } from '@mint-lib/tw-utils';
import { cva, type VariantProps } from 'class-variance-authority';

import { typographyVariants } from './typography.jsx';

// There are only design elements for Alert component, you need to use Alert component from patterns/Alert/Alert.tsx instead of this component

const alertVariants = cva('flex w-full gap-2 rounded-lg border', {
  variants: {
    severity: {
      info: 'border-info-main bg-background-info fill-info-main text-text-info',
      warning:
        'border-warning-main bg-background-warning fill-warning-main text-text-warning',
      error:
        'border-error-main bg-background-error fill-error-main text-text-error',
      success:
        'border-success-main bg-background-success fill-success-main text-text-success',
    },
    variant: {
      inline: 'h-10 py-2 pr-2 pl-3',
      multiline: 'min-h-fit py-3 pr-2 pl-3',
    },
  },
  defaultVariants: {
    variant: 'inline',
    severity: 'info',
  },
});

function Alert({
  className,
  variant,
  severity,
  ...props
}: React.ComponentProps<'div'> & VariantProps<typeof alertVariants>) {
  return (
    <div
      data-slot="alert"
      role="alert"
      className={cn(alertVariants({ variant, severity }), className)}
      {...props}
    >
      {props.children}
    </div>
  );
}

function AlertTitle({ className, ...props }: React.ComponentProps<'h6'>) {
  return (
    <h6
      data-slot="alert-title"
      className={cn(
        typographyVariants({
          variant: 'h6',
        }),

        className,
      )}
      {...props}
    >
      {props.children}
    </h6>
  );
}

function AlertDescription({ className, ...props }: React.ComponentProps<'p'>) {
  return (
    <p
      data-slot="alert-description"
      className={cn(
        typographyVariants({
          variant: 'bodyShort01',
        }),
        className,
      )}
      {...props}
    >
      {props.children}
    </p>
  );
}

export { Alert, AlertTitle, AlertDescription };
